<template>
  <v-container fluid fill-height>
    <v-row no-gutters align="center" justify="space-around">
      <v-col cols="12" md="8">
        <v-card ref="form">
          <v-card-title>Ingresa un correo y una contraseña para terminar el registro</v-card-title>
          <v-card-text>
            <v-text-field
              ref="email"
              v-model="email"
              :rules="[() => !!email || 'Este campo es requerido']"
              label="Email *"
              required
            />

            <v-text-field
              ref="password"
              v-model="password"
              :rules="[
                () => !!password || 'Este campo es requerido',
                () =>
                  (!!password &&
                    password.length >= 8 &&
                    password.length <= 12) ||
                  'Contrasena debe ser mayor a 8 caracteres o menor a 12 '
              ]"
              :append-icon="show1 ? 'mdi-account' : 'mdi-account-alert'"
              :type="show1 ? 'text' : 'password'"
              label="Contraseña *"
              counter="12"
              required
            />
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="cancel">Cancelar</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" text type="submit" @click="submit">Registrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="loading">{{ text }}</v-snackbar>
  </v-container>
</template>




<script>
import * as firebase from "firebase";
import axios from "axios";

export default {
  created() {
    // eslint-disable-next-line no-console
    console.log("Parametros:" + this.$route.params.orcid_id);
    this.orcid_id = this.$route.params.orcid_id;
  },
  data() {
    return {
      orcid_id: "",
      email: "",
      password: "",
      show1: false,
      loading: false,
      text: "Cargando los datos, espere",
      timeout: 7000
    };
  },

  methods: {
    submit: function() {
      var user;
      this.loading = true;
      var convert = require("xml2js");
      // eslint-disable-next-line no-console
      console.log("Ingresando datos del usuario: ");
      const newUser = {
        id: "",
        orcid_id: this.orcid_id,
        email: this.email,
        experience: {},
        education: {},
        projects: {},
        about_me: "",
        first_name: "",
        last_name: "",
        country: ""
      };

      // eslint-disable-next-line no-console
      console.log(newUser);

      let config = {
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "POST",
          "Access-Control-Allow-Headers": "*"
        }
      };
      var body = new URLSearchParams();
      body.append("client_id", "APP-6T2U5INEDICQNRFN");
      body.append("client_secret", "aa4a4568-8134-4af9-bb82-8fa717ea577c");
      body.append("grant_type", "client_credentials");
      body.append("scope", "/read-public");
      axios
        .post(
          "https://cors-anywhere.herokuapp.com/https://orcid.org/oauth/token",
          body,
          config
        )
        .then(response => {
          // eslint-disable-next-line no-console
          console.log("Success", response);
          const configGet = {
            headers: {
              Accept: "application/vnd.orcid+xml",
              Authorization: "Bearer",
              //"Access token": response.access_token,
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "POST",
              "Access-Control-Allow-Headers": "*"
            }
          };
          var idData = new URLSearchParams();
          idData.append("Access token", response.access_token);
          axios
            .get(
              "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                this.orcid_id +
                "/employments",
              idData,
              configGet
            )
            .then(response => {
              convert.parseString(response.data, function(err, result) {
                // eslint-disable-next-line no-console
                console.log(result);
                var employments =
                  result["activities:employments"][
                    "employment:employment-summary"
                  ];
                if (employments.length > 0) {
                  for (let i = 0; i < employments.length; i++) {
                    const employment = {
                      initialDate:
                        employments[i]["common:start-date"][0][
                          "common:day"
                        ][0] +
                        "-" +
                        employments[i]["common:start-date"][0][
                          "common:month"
                        ][0] +
                        "-" +
                        employments[i]["common:start-date"][0][
                          "common:year"
                        ][0],
                      roleTitle: employments[i]["employment:role-title"][0],
                      organization:
                        employments[i]["employment:organization"][0][
                          "common:name"
                        ][0],
                      city:
                        employments[i]["employment:organization"][0][
                          "common:address"
                        ][0]["common:city"][0] +
                        ", " +
                        employments[i]["employment:organization"][0][
                          "common:address"
                        ][0]["common:region"][0] +
                        ", " +
                        employments[i]["employment:organization"][0][
                          "common:address"
                        ][0]["common:country"][0]
                    };
                    newUser.experience[i] = employment;
                  }
                }
              });
            })
            .catch(error => {
              // eslint-disable-next-line no-console
              console.log(error);
            })
            .finally(() => {
              axios
                .get(
                  "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                    this.orcid_id +
                    "/biography",
                  idData,
                  configGet
                )
                .then(response => {
                  convert.parseString(response.data, function(err, result) {
                    // eslint-disable-next-line no-console
                    console.log(result);
                    var biography =
                      result["personal-details:biography"][
                        "personal-details:content"
                      ];
                    if (biography) {
                      newUser.about_me = biography[0];
                    }
                  });
                })
                .catch(error => {
                  // eslint-disable-next-line no-console
                  console.log(error);
                })
                .finally(() => {
                  axios
                    .get(
                      "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                        this.orcid_id +
                        "/educations",
                      idData,
                      configGet
                    )
                    .then(response => {
                      convert.parseString(response.data, function(err, result) {
                        // eslint-disable-next-line no-console
                        console.log(result);
                        var educations =
                          result["activities:educations"][
                            "education:education-summary"
                          ];
                        if (educations.length > 0) {
                          for (let i = 0; i < educations.length; i++) {
                            const ed = {
                              organization:
                                educations[i]["education:organization"][0][
                                  "common:name"
                                ][0],
                              city:
                                educations[i]["education:organization"][0][
                                  "common:address"
                                ][0]["common:city"][0] +
                                ", " +
                                educations[i]["education:organization"][0][
                                  "common:address"
                                ][0]["common:region"][0] +
                                ", " +
                                educations[i]["education:organization"][0][
                                  "common:address"
                                ][0]["common:country"][0],
                              role_title:
                                educations[i]["education:role-title"][0]
                            };
                            newUser.education[i] = ed;
                          }
                        }
                      });
                    })
                    .catch(error => {
                      // eslint-disable-next-line no-console
                      console.log(error);
                    })
                    .finally(() => {
                      axios
                        .get(
                          "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                            this.orcid_id +
                            "/works",
                          idData,
                          configGet
                        )
                        .then(response => {
                          convert.parseString(response.data, function(
                            err,
                            result
                          ) {
                            // eslint-disable-next-line no-console
                            console.log(result);
                            var activities =
                              result["activities:works"]["activities:group"];
                            if (activities.length > 0) {
                              for (let i = 0; i < activities.length; i++) {
                                const act = {
                                  title:
                                    activities[i]["work:work-summary"][0][
                                      "work:title"
                                    ][0]["common:title"][0],
                                  type:
                                    activities[i]["work:work-summary"][0][
                                      "work:type"
                                    ][0],
                                  date:
                                    activities[i]["work:work-summary"][0][
                                      "common:publication-date"
                                    ][0]["common:day"][0] +
                                    "-" +
                                    activities[i]["work:work-summary"][0][
                                      "common:publication-date"
                                    ][0]["common:month"][0] +
                                    "-" +
                                    activities[i]["work:work-summary"][0][
                                      "common:publication-date"
                                    ][0]["common:year"][0]
                                };
                                newUser.projects[i] = act;
                              }
                            }
                          });
                        })
                        .catch(error => {
                          // eslint-disable-next-line no-console
                          console.log(error);
                        })
                        .finally(() => {
                          axios
                            .get(
                              "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                                this.orcid_id +
                                "/personal-details",
                              idData,
                              configGet
                            )
                            .then(response => {
                              convert.parseString(response.data, function(
                                err,
                                result
                              ) {
                                // eslint-disable-next-line no-console
                                console.log(result);
                                var details =
                                  result["personal-details:personal-details"][
                                    "personal-details:name"
                                  ];
                                if (details.length > 0) {
                                  newUser.first_name =
                                    details[0][
                                      "personal-details:given-names"
                                    ][0];
                                  newUser.last_name =
                                    details[0][
                                      "personal-details:family-name"
                                    ][0];
                                }
                              });
                            })
                            .catch(error => {
                              // eslint-disable-next-line no-console
                              console.log(error);
                            })
                            .finally(() => {
                              axios
                                .get(
                                  "https://cors-anywhere.herokuapp.com/https://pub.orcid.org/v2.0/" +
                                    this.orcid_id +
                                    "/address",
                                  idData,
                                  configGet
                                )
                                .then(response => {
                                  convert.parseString(response.data, function(
                                    err,
                                    result
                                  ) {
                                    // eslint-disable-next-line no-console
                                    console.log(result);
                                    var add =
                                      result["address:addresses"][
                                        "address:address"
                                      ];
                                    if (add.length > 0) {
                                      newUser.country =
                                        add[0]["address:country"][0];
                                    }
                                  });
                                })
                                .catch(error => {
                                  // eslint-disable-next-line no-console
                                  console.log(error);
                                })
                                .finally(() => {
                                  const CryptoJS = require("crypto-js");
                                  const hash = CryptoJS.SHA3(
                                    "participainteligente"
                                  ).toString();
                                  const encrypted = CryptoJS.AES.encrypt(
                                    this.password,
                                    hash
                                  ).toString();
                                  localStorage.setItem(
                                    "pswd",
                                    encrypted
                                  );
                                  firebase
                                    .auth()
                                    .createUserWithEmailAndPassword(
                                      this.email,
                                      this.password
                                    )
                                    .then(user => {
                                      this.loading = false;
                                      // eslint-disable-next-line no-console
                                      console.log(user);
                                      newUser.id = user.user.uid;
                                      this.$store
                                        .dispatch(
                                          "user/signUpUserOrcid",
                                          newUser
                                        )
                                        .then(() => {
                                          this.$router.push({
                                            name: "projects"
                                          });
                                          location.reload();
                                        });
                                    })
                                    .catch(err => {
                                      this.loading = false;
                                      if (
                                        err.message ===
                                        "The email address is already in use by another account."
                                      ) {
                                        this.error = true;
                                      } else {
                                        // eslint-disable-next-line no-console
                                        console.log(
                                          "Credenciales incorrectas limpiando los text fields.."
                                        );
                                        this.alert = true;
                                        this.email = "";
                                        this.password = "";
                                      }
                                      // eslint-disable-next-line no-console
                                      console.log("Error" + err.message);
                                    })
                                    .finally(() => {
                                      if (this.error) {
                                        // eslint-disable-next-line no-console
                                        console.log(this.email);
                                        var _this = this;
                                        firebase
                                          .firestore()
                                          .collection("User")
                                          .where(
                                            "email.primary",
                                            "==",
                                            _this.email
                                          )
                                          .get()
                                          .then(function(querysnapshot) {
                                            querysnapshot.forEach(function(
                                              doc
                                            ) {
                                              user = doc.data();
                                              user.id = doc.id;
                                              firebase
                                                .firestore()
                                                .collection("User")
                                                .doc(user.id)
                                                .update({
                                                  orcid_id: _this.orcid_id
                                                })
                                                .then(() => {
                                                  const CryptoJS = require("crypto-js");
                                                  const hash = CryptoJS.SHA3(
                                                    "participainteligente"
                                                  ).toString();
                                                  const encrypted = CryptoJS.AES.encrypt(
                                                    this.password,
                                                    hash
                                                  ).toString();
                                                  localStorage.setItem(
                                                    "pswd",
                                                    encrypted
                                                  );
                                                  // eslint-disable-next-line no-console
                                                  console.log(
                                                    "OrcidID agregado"
                                                  );
                                                })
                                                .catch(err => {
                                                  // eslint-disable-next-line no-console
                                                  console.log(
                                                    "No se pudo agregar el OrcidID: " +
                                                      err.message
                                                  );
                                                })
                                                .finally(() => {
                                                  firebase
                                                    .auth()
                                                    .signInWithEmailAndPassword(
                                                      _this.email,
                                                      _this.password
                                                    )
                                                    .then(user => {
                                                      _this.text =
                                                        "Redirigiendo...";
                                                      _this.loading = true;
                                                      // eslint-disable-next-line no-console
                                                      console.log(
                                                        "Retrive user"
                                                      );
                                                      _this.$store.dispatch(
                                                        "user/login",
                                                        user
                                                      );
                                                      _this.$router.push({
                                                        name: "projects"
                                                      });
                                                    })
                                                    .catch(err => {
                                                      // eslint-disable-next-line no-console
                                                      console.log(
                                                        "Credenciales incorrectas limpiando los text fields.."
                                                      );
                                                      // eslint-disable-next-line no-console
                                                      console.log(
                                                        "Error" + err.message
                                                      );
                                                    });
                                                });
                                            });
                                          })
                                          .catch(err => {
                                            // eslint-disable-next-line no-console
                                            console.log(
                                              "No se pudo obtener usuario de la base: " +
                                                err.message
                                            );
                                          });
                                      }
                                    });
                                });
                            });
                        });
                    });
                });
            });
        })
        .catch(e => {
          // eslint-disable-next-line no-console
          console.log("Error", e);
        });
    },

    resetForm() {
      this.email = "";
      this.password = "";
    },
    cancel() {
      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style>
.center {
  text-align: center;
}
</style>

